var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_279_1",
    "data-name": "Component 279 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15219",
    "data-name": "Group 15219",
    transform: "translate(-64 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15216",
    "data-name": "Group 15216",
    transform: "translate(73.253 41.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15213",
    "data-name": "Group 15213",
    transform: "translate(0.23 0.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15217",
    "data-name": "Group 15217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6532",
    "data-name": "Rectangle 6532",
    width: 4.901,
    height: 4.901,
    fill: "none",
    stroke: "#0745d3",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6533",
    "data-name": "Rectangle 6533",
    width: 4.901,
    height: 4.901,
    transform: "translate(8.248 8.248)",
    fill: "none",
    stroke: "#0745d3",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    x2: 3.347,
    y2: 3.347,
    transform: "translate(5.131 5.131)",
    fill: "none",
    stroke: "#0745d3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15215",
    "data-name": "Group 15215",
    transform: "translate(0.23 0.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15218",
    "data-name": "Group 15218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14645",
    "data-name": "Path 14645",
    d: "M27.376,5.818V.5H22.057",
    transform: "translate(-14.118 -0.5)",
    fill: "none",
    stroke: "#0745d3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14646",
    "data-name": "Path 14646",
    d: "M.5,21.5v5.523H6.023",
    transform: "translate(-0.5 -13.769)",
    fill: "none",
    stroke: "#0745d3",
    strokeWidth: 1.5
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6534",
    "data-name": "Rectangle 6534",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.5ca26ec64bec316abe0f477688f2196b.svg";
export { ForwardRef as ReactComponent };